module.exports = __webpack_public_path__ + "static/media/b0b84e4d-2164-45c7-a674-1662f19f3ba6.d67d67c3.woff2";